module.exports = __webpack_public_path__ + "img/Tmall-back.1919e5a5.png";